import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps, Text } from '@frontend/design-system';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';
import { BackendError, BackendErrorDetails } from './BackendErrorDetails';

type ScheduleRequestErrorModalProps = {
  modalProps: ModalControlModalProps;
  onConfirm: (override?: boolean) => void;
  backendError?: BackendError;
};

export const ScheduleRequestErrorModal = ({ modalProps, onConfirm, backendError }: ScheduleRequestErrorModalProps) => {
  const { t } = useTranslation('scheduleCalendarRequest');
  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Whoops!')}
      message={
        <div css={{ display: 'flex', flexDirection: 'column', gap: 'var(--fabric-space-gap-md)' }}>
          <Text>{t('We were unable to send this appointment to your practice management system.')}</Text>
          <Text>
            {t(
              "Approving this request will update its status, but won't add it to any calendar. If you've selected to send a message, the patient will be notified. You'll need to schedule the appointment manually in your practice management system."
            )}
          </Text>
        </div>
      }
      onConfirm={onConfirm}
      cancelLabel={t('Return to request')}
      confirmLabel={t('Approve anyway')}
      cancelTrackingId={ScheduleRequestsTrackingIds.requestErrorConfirmationModalCancelBtn}
      confirmTrackingId={ScheduleRequestsTrackingIds.requestErrorConfirmationModalConfirmBtn}
    >
      {backendError && <BackendErrorDetails backendError={backendError} />}
    </ConfirmationModal>
  );
};
